import { camelCase, isObject, snakeCase } from 'lodash';

import { isUpperCase } from './string';

// Convert object keys from camelCase to snake_case if the key is not ending with a number
export const defaultToSnakeCase = (string: string) =>
  /\d$/.test(string) ? string : snakeCase(string);

export const objectKeysCamelToSnakeCase = (
  data: unknown,
  {
    toSnakeCase = defaultToSnakeCase,
    excludeKeys = [],
  }: { toSnakeCase?: (string: string) => string; excludeKeys?: string[] } = {}
) => {
  if (Array.isArray(data)) {
    return data.map((item) => objectKeysCamelToSnakeCase(item, { toSnakeCase, excludeKeys }));
  }

  if (!isObject(data) || data instanceof File) {
    return data;
  }

  return Object.entries(data).reduce((obj, [key, value]) => {
    if (excludeKeys.includes(key)) {
      return {
        ...obj,
        [key]: value,
      };
    }

    let newKey = toSnakeCase(key);
    const segments = key.split('.');

    if (segments.length > 1) {
      newKey = segments.map((segment) => toSnakeCase(segment)).join('.');
    }

    return {
      ...obj,
      [newKey]: objectKeysCamelToSnakeCase(value, { toSnakeCase, excludeKeys }),
    };
  }, {});
};

export const objectKeysSnakeCaseToCamelCase = (data: unknown) => {
  if (Array.isArray(data)) {
    return data.map((item) => objectKeysSnakeCaseToCamelCase(item));
  }

  if (!isObject(data)) {
    return data;
  }

  return Object.entries(data).reduce((obj, [key, value]) => {
    let newKey = key;

    if (!(key.startsWith('__') && key.endsWith('__')) && !isUpperCase(key)) {
      newKey = camelCase(key);
    }

    return {
      ...obj,
      [newKey]: objectKeysSnakeCaseToCamelCase(value),
    };
  }, {});
};

export const removeUnderscore = (string: string) => string?.replace(/_/g, ' ');
